"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapBannerData = void 0;
// Utils
const mapImages_utility_1 = require("../../../utils/mapImages.utility");
const mapBannerData = (proposition) => {
    const { content, feedback, locationId } = proposition;
    const mappedImages = (0, mapImages_utility_1.mapImages)(content.images);
    return { ...content, feedback, locationId, images: mappedImages };
};
exports.mapBannerData = mapBannerData;
//# sourceMappingURL=mapper.js.map